import { render, staticRenderFns } from "./NoticeBar.vue?vue&type=template&id=1ff908ec&scoped=true&"
import script from "./NoticeBar.vue?vue&type=script&lang=ts&"
export * from "./NoticeBar.vue?vue&type=script&lang=ts&"
import style0 from "./NoticeBar.vue?vue&type=style&index=0&id=1ff908ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@rakete/cli-plugin-vue/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ff908ec",
  null
  
)

export default component.exports